import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';
import dayjs from 'dayjs';

import { makePercentageValue } from '@src/components/card/courseProduct/utils';
import useCurrentCourse from '@src/hooks/useCurrentCourse';
import { showStudent, accessRightText } from '@src/utils/course';

import ProgressContent from './progressContent';

const ProgressWrapper = styled.div`
	position: relative;

	@media ${props => props.theme.device.tablet} {
		display: flex;
		flex-direction: row-reverse;
		justify-content: center;
	}

	@media ${props => props.theme.device.smTablet} {
		display: flex;
		flex-direction: row-reverse;
		justify-content: center;
	}
`;

const Progress = (): JSX.Element => {
	const { t } = useTranslation();
	const { currentCourse: {
		status,
		goal_backers,
		total_backers,
		fund_end_at: fundEndAt,
		preparation_end_at,
		students,
		advance_settings: advanceSettings,
	} } = useCurrentCourse();
	const startTime = dayjs(dayjs(new Date())).valueOf();
	const isExpired = dayjs(startTime).isAfter(dayjs(fundEndAt));
	const percentage = makePercentageValue({
		isExpired, totalBackers: total_backers, goalBackers: goal_backers,
	});
	const showStudents = showStudent({ advanceSettings, students });
	const accessRight = accessRightText({ advanceSettings, t });

	return (
		<ProgressWrapper>
			<ProgressContent
				status={status}
				fundraisingEndTime={fundEndAt}
				preparationEndTime={preparation_end_at}
				percentage={percentage}
				showStudents={showStudents}
				accessRight={accessRight}
			/>
		</ProgressWrapper>
	);
};

export default Progress;
